import { useNavigate } from "react-router-dom";
import React from "react";
import { Information } from "../components";

interface ICnt_CreditorInfo {
  caseNo: number;
}

const Cnt_CreditorInfo: React.FC<ICnt_CreditorInfo> = (props) => {
  const navigate = useNavigate();

  const onMinimize = () => {
    navigate(`/case/${props.caseNo}`);
  };

  return <Information onMinimize={onMinimize} />;
};

export default Cnt_CreditorInfo;
